// ! Only one tablist per page atm
import TabItem from '../_tab-item/mando-ui.tab-item';
import TabPanel from '../_tabpanel/mando-ui.tabpanel';
import jump from 'jump.js';

const mediaQuery = window.matchMedia('(min-width: 61.25em)');

const tabsComp = document.querySelector('.js-tabs');
const tablist = tabsComp?.querySelector('.js-tablist');
const nav = tabsComp?.querySelector('.js-tabs-toc');
const scrollTarget = tabsComp?.querySelector(`.js-scroll-target`);

const tabs = [];
const panels = [];

const tablistItemNode = [...tabsComp.getElementsByClassName('js-tab-item')];
const tabPanelNode = [...tabsComp.getElementsByClassName('js-tabpanel')];

const classes = {
  tabBtn: '.js-tab-trigger',
  resetBtn: '.js-tabs-reset',
};

let settings = {
  panelOpenByDefault: true,
  defaultPanelIndex: 0,
};

function instantiateSemantics() {
  // once js is loaded, remove nav semantics from no-js fallback
  nav.setAttribute('role', 'presentation');
  nav.removeAttribute('aria-label');
}

function instantiateTabs() {
  tablistItemNode.forEach((node, index) => {
    const selected = settings.panelOpenByDefault ? index === settings.defaultPanelIndex : false;

    const tab = new TabItem({
      container: tabsComp,
      item: node,
      mediaQuery,
      selected: selected,
      trigger: node.querySelector(classes.tabBtn),
      index,
      scrollTarget,
    });
    tab.init();
    tabs.push(tab);
  });

  tabs.forEach((tab) => {
    const btn = tab.trigger;
    btn.addEventListener('keydown', tabsKeyHandler);
  });
}

function instantiatePanels() {
  tabPanelNode.forEach((node, index) => {
    const isDefaultPanel =
      settings.panelOpenByDefault === true && index === settings.defaultPanelIndex;

    const resetBtn = settings.panelOpenByDefault ? null : node.querySelector(classes.resetBtn);

    const panel = new TabPanel({
      container: tabsComp,
      item: node,
      mediaQuery,
      trigger: resetBtn,
    });
    panel.init();
    panels.push(panel);

    if (isDefaultPanel) {
      panel.item.removeAttribute('hidden');
    }
  });
}

function instantiateResetButtons() {
  if (settings.panelOpenByDefault === true) {
    return;
  }
  panels.forEach((panel) => panel.trigger.removeAttribute('hidden'));
}

// Allow Arrow key focus of tab trigger-buttons
function calcTabIndex(index, key) {
  const calcIndex = {
    ArrowLeft: index - 1,
    ArrowUp: index - 1,
    ArrowRight: index + 1,
    ArrowDown: index + 1,
  };

  return calcIndex[key];
}

function tabsKeyHandler(e) {
  const index = parseInt(this.dataset.tabIndex, 10);

  if (
    ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') && index > 0) ||
    ((e.key === 'ArrowRight' || e.key === 'ArrowDown') &&
      index < parseInt(tabsComp.dataset.tabsCount - 1, 10))
  ) {
    e.preventDefault();
    tabsComp.querySelectorAll(classes.tabBtn)[calcTabIndex(index, e.key)].focus();
  }
}

function setAriaOrientation() {
  if (!tablist) return;

  mediaQuery.matches
    ? tablist.setAttribute('aria-orientation', 'horizontal')
    : tablist.setAttribute('aria-orientation', 'vertical');
}

function matchAttr(trimTerm) {
  const firstMatchingElement = tabsComp?.querySelector(`.js-tab-trigger[data-panel='${trimTerm}']`);
  const urlParams = new URLSearchParams(window.location.search);
  const accordionQuery = urlParams.get('search');

  if (firstMatchingElement) {
    firstMatchingElement.click();

    if (!accordionQuery) {
      jump(firstMatchingElement, {
        a11y: true,
        duration: 1200,
      });
    }
  }
}

function init() {
  if (!tabsComp) {
    return;
  }

  if (tablistItemNode.length > 0 && tabPanelNode.length > 0 && nav) {
    instantiateSemantics();
    instantiateTabs();
    instantiatePanels();
    instantiateResetButtons();
    setAriaOrientation();

    mediaQuery.addEventListener('change', setAriaOrientation);
  }

  document.addEventListener('readystatechange', () => {
    // open tab if query param is present eg `?panel=panel-2`
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('panel');
    if (searchTerm) {
      matchAttr(searchTerm.replace(/\s+/g, ''));
    }
  });
}

export default init;
